import { Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Slide } from "@mui/material";
import { TransitionProps } from "@mui/material/transitions";
import { Icons } from "assets";
import React from "react";
import styles from "./style.module.scss";

interface ModalProps {
  modalHeading: string;
  modalText?: string;
  viewOnly?: boolean;
  showTextArea?: boolean;
  showButtons?: boolean;
  state: boolean;
  handleClose: any;
  handleSave?: () => {};
  receiptImage?: string;
  handleConfirm?: any;
  textAreaMsg?: string;
  textAreaHandler?: any;
  reject?: boolean;
  showReceipt?: boolean;
}
const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});
const Modal = ({
  modalHeading,
  state,
  viewOnly,
  showButtons,
  handleClose,
  receiptImage,
  showTextArea,
  modalText,
  textAreaMsg,
  textAreaHandler,
  handleConfirm,
  reject,
  showReceipt,
}: ModalProps) => {
  return (
    <Dialog
      open={state}
      TransitionComponent={Transition}
      keepMounted
      onClose={handleClose}
      aria-labelledby="alert-dialog-slide-title"
      aria-describedby="alert-dialog-slide-description"
      fullWidth
    >
      <Icons.CrossIcon
        className={styles.crossIcon}
        onClick={() => handleClose()}
      />
      <Box padding={"20px"} position={"relative"}>
        {/* <Icons.CrossIcon
            className={styles.crossIcon}
            onClick={() => handleClose()}
          /> */}
        <Box>
          {reject && (
            <Icons.RejectionIcon
              style={{ height: "60px", width: "60px", marginRight: "15px" }}
            />
          )}
          <DialogTitle id="alert-dialog-slide-title" padding={"0px !important"}>
            {modalHeading}
          </DialogTitle>
        </Box>
        <DialogContent sx={{ padding: "0px" }}>
          {!viewOnly && modalText && (
            <DialogContentText id="alert-dialog-slide-description">
              {reject && (
                <textarea
                  value={modalText}
                  className={styles.textAreaReject}
                  disabled
                />
              )}
            </DialogContentText>
          )}
          {showTextArea && (
            <>
              <textarea
                autoFocus
                value={textAreaMsg}
                onChange={textAreaHandler}
                className={styles.textarea}
              />
              <div className={styles.note}>{modalText}</div>
            </>
          )}
          {viewOnly && receiptImage && (
            <div className={styles.receiptImg}>
              <img
                src={receiptImage}
                alt="Receipt"
                className={styles.receiptImg}
              />
            </div>
          )}
        </DialogContent>
        {showButtons && (
          <DialogActions
            sx={{
              display: "flex",
              justifyContent: "center",
              padding: "0px !important",
              marginTop: "20px",
            }}
          >
            {!reject && !showReceipt && (
              <Button
                className={styles.saveBtn}
                onClick={handleConfirm}
                color="primary"
              >
                Save
              </Button>
            )}
            <Button onClick={handleClose} className={styles.cancelBtn}>
              {reject || showReceipt ? "Close" : "Cancel"}
            </Button>
          </DialogActions>
        )}
      </Box>
    </Dialog>
  );
};

export default Modal;
